import React from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, FormControl, InputLabel } from '@material-ui/core/';
import useStyles from './styles';

const CustomTextField = ({ input: { name, type, ...restInput }, fullWidth, id, label, meta, ...rest }) => {
  const classes = useStyles();
  const serverError = !meta.dirtySinceLastSubmit && meta.submitError;
  const isError = Boolean((meta.error && meta.touched) || serverError);

  return (
    <FormControl {...restInput} fullWidth={fullWidth} error={isError}>
      <InputLabel className={classes.label} shrink htmlFor={id}>
        {label}
      </InputLabel>
      <div className={classes.inputWrapper}>
        <input type="color" className={classes.inputField} id={id} name={name} {...rest} {...restInput} />
      </div>
      {isError && (
        <FormHelperText id="outlined-weight-helper-text" error>
          {meta.error || serverError}
        </FormHelperText>
      )}
    </FormControl>
  );
};

CustomTextField.defaultProps = {
  fullWidth: false,
};

CustomTextField.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
  }).isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.shape().isRequired,
  id: PropTypes.string.isRequired,
  fullWidth: PropTypes.bool,
};

export default CustomTextField;
